import * as React from 'react';
import _ from 'lodash';
import { Paper, makeStyles, Grid, Button, FormControl, FormLabel, RadioGroup, Radio, FormControlLabel, TextField } from '@material-ui/core';
import { SelectWithLabel } from '../../utils/selectWithLabel'
import { useDispatch, useSelector } from 'react-redux';
import { updateBag, postBag, deleteBag, setCurBagLoc, setBagToDelete } from "../../store/departures";

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    // padding: theme.spacing(2, 4, 3),
  },
  paperMobile: {
    position: 'absolute',
    width: '80%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
  },
  // sendingPaper: {
  //   position: 'absolute',
  //   width: '20%',
  //   height: '10%',
  //   backgroundColor: theme.palette.background.paper,
  //   border: '2px solid #000',
  //   boxShadow: theme.shadows[5],
  //   marginTop: '12%',
  //   padding: '2px 4px 2px 4px'
  // },
  heavyBag: {
    color: 'rgba(236, 45, 45, 1)'
  },
  headerCells: {
    borderBottom: '2px solid gray',
    paddingTop: '5px',
    paddingBottom: '5px'
  },
  bodyCells: {
    borderBottom: '2px solid gray',
    paddingTop: '10px',
    paddingBottom: '10px'
  }
}));

export const BagModal = (props) => {
  const pax = props.rows[props.paxInfo]
  const pjd = pax.pjd
  const bags = _.uniqBy(pax.bagWeight, 'key') || []
  const [addBag, setAddBag] = React.useState(false)
  const [editBags, setEditBags] = React.useState(false)
  const [confirmation, setConfirmation] = React.useState(false)
  const [editBag, setEditBag] = React.useState(' ')
  const [newBagType, setNewBagType] = React.useState('checked')
  const [newBagWeight, setNewBagWeight] = React.useState(0)
  const [newBagNotes, setNewBagNotes] = React.useState(' ')
  const bagToDelete = useSelector(state => state.entities.departures.bagToDelete)
  const classes = useStyles()
  const dispatch = useDispatch()
  let screenWidth = window.screen.width

  const getBagType = (bag) => {
    let bagTypes = bag && bag.baggageType ? bag.baggageType : ''
    if (bagTypes.regular) {
      return "checked"
    }
    else if (bagTypes.carry) {
      return "carry-on"
    }
    else if (bagTypes.valet) {
      return "valet"
    }
    else {
      return ' '
    }
  }

  const getBagWeightTotal = (bagArr) => {
    let total = 0
    for (let i = 0; i < bagArr.length; i++) {
      const bag = bagArr[i];
      total += bag.weight.amount
    }
    total += ' lbs'
    return total
  }

  // NOTE // form-handling for editing a bag
  const changeEditBag = (action, val) => {
    let editBagCopy = _.cloneDeep(editBag)
    if (action == 'type') {
      editBagCopy.baggageType = {
        carry: val == 'carry-on',
        regular: val == 'checked',
        valet: false
      }
    }
    else if (action == 'weight') {
      editBagCopy.weight.amount = val
    }
    else if (action == 'notes') {
      editBagCopy.notes = val
    }
    setEditBag(editBagCopy)
  }

  const handleEditBag = () => {
    // depKey, pKey, pjdKey, bagKey, output
    let bagCopy = _.cloneDeep(editBag)
    let depKey = props.dep.key
    let paxKey = pax.key
    let pjdKey = pjd.key
    let bagKey = bagCopy.key || false
    let bagTimestamp = bagCopy.timestamp || false
    if (bagKey && bagTimestamp) {
      dispatch(updateBag(depKey, paxKey, pjdKey, bagKey, bagCopy))
    }
  }

  const handlePostBag = () => {
    dispatch(setCurBagLoc({dep: props.dep, pax: pax}))
    let depKey = props.dep.key
    let pKey = pax.key
    let pjdKey = pjd.key

    let newBag = {
      baggageType: {
        carry: newBagType == 'carry-on',
        regular: newBagType == 'checked',
        valet: false
      },
      destinationAirport: pjd.destinationAirport,
      originAirport: pjd.originAirport,
      notes: newBagNotes,
      licensePlate: {
        leadingDigit: 0,
        accountingCode: '000',
        number: Math.floor(100000 + Math.random() * 900000).toString()
      },
      weight: {
        amount: Number(newBagWeight)
      }
    }

    dispatch(postBag(depKey, pKey, pjdKey, newBag))
  }

  const handleDeleteConfirmation = (bag) => {
    dispatch(setBagToDelete(bag))
    setConfirmation(true)
  }

  const handleDeleteBag = () => {
    let depKey = props.dep.key
    let pKey = pax.key
    let pjdKey = pjd.key
    let bagKey = bagToDelete.key
    dispatch(deleteBag(depKey, pKey, pjdKey, bagKey))
    setConfirmation(false)
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      <Paper className={screenWidth <= 775 ? classes.paperMobile : classes.paper}>
        <Grid container item xs={12}>
          <Grid container item xs={12} justify="center" style={{backgroundColor: '#3f51b5'}}>
            <h2>Bags</h2>
          </Grid>
          {
            editBags ?
            <Grid container item xs={12} justify="center" style={{marginTop: '10px', marginBottom: '10px'}}>
            {/* SECTION // Edit Bag */}
            <Grid container item xs={10} justify="center" style={{border: '2px solid gray', borderRadius: '10px'}}>
              <Grid container item xs={12} justify="center">
                <FormLabel component="legend">Edit Bag</FormLabel>
              </Grid>
              <Grid container item xs={3}>
                <FormControl component="fieldset">
                  <RadioGroup aria-label="bag-type" name="gender1" value={getBagType(editBag)} onChange={(e) => {changeEditBag('type', e.target.value)}}>
                    <FormControlLabel value="checked" control={<Radio />} label="Checked" />
                    <FormControlLabel value="carry-on" control={<Radio />} label="Carry-on" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid container item xs={3} alignContent="center" style={{marginRight: '5px'}}>
                <TextField
                  value={editBag.weight.amount}
                  onChange={(e) => {changeEditBag('weight', e.target.value)}}
                  id="bag-weight"
                  label="Weight"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid container item xs={3} alignContent="center" style={{marginBottom: '5px'}}>
                <TextField
                  value={editBag.notes}
                  onChange={(e) => {changeEditBag('notes', e.target.value)}}
                  multiline={true}
                  rows={3}
                  id="bag-notes"
                  label="Notes"
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="filled"
                />
              </Grid>
            </Grid>
            <Grid container item xs={8} justify="center" style={{paddingTop: '10px'}}>
              <Button variant="contained" size="small" style={{marginRight: '10px', backgroundColor: '#eb494e'}} onClick={() => {setEditBags(false)}}>cancel</Button>
              <Button variant="contained" size="small" style={{backgroundColor: '#03fc66'}} onClick={() => {handleEditBag()}}>save</Button>
            </Grid>
            {/* !SECTION */}
          </Grid> :
            <Grid container>
              { confirmation ? 
                <Grid container justify="center" style={{marginBottom: '5px'}}>
                  <Grid container item xs={12} justify="center">
                    <h3>Are you sure you want to delete this bag?</h3>
                  </Grid>
                  <Grid container item xs={2} justify="center">
                    <Button variant="contained" size="small" style={{backgroundColor: '#03fc66'}} onClick={() => {handleDeleteBag()}}>Yes</Button>
                  </Grid>
                  <Grid container item xs={2} justify="center">
                    <Button variant="contained" size="small" style={{backgroundColor: '#eb494e'}} onClick={() => {setConfirmation(false)}}>No</Button>
                  </Grid>
                </Grid> :
                <Grid container>
                  <Grid container item xs={12} justify="center">
                    <Grid container item xs={3} justify="center" className={classes.headerCells}><b>Weight</b></Grid>
                    <Grid container item xs={3} justify="center" className={classes.headerCells}><b>Type</b></Grid>
                    <Grid container item xs={3} justify="center" className={classes.headerCells}><b>Notes</b></Grid>
                    <Grid item xs={2} className={classes.headerCells}></Grid>
                      {
                        bags.map((bag, index) => (
                          <Grid container justify="center" key={index}>
                            <Grid container item xs={3} alignContent="center" justify="center" className={classes.bodyCells}> {bag.weight.amount + ' lbs'} </Grid>
                            <Grid container item xs={3} alignContent="center" justify="center" className={classes.bodyCells}> {getBagType(bag)} </Grid>
                            <Grid container item xs={3} alignContent="center" justify="center" className={classes.bodyCells}>{bag.notes.slice(0, 15) + ( bag.notes.length >= 15 ? '...' : '')}</Grid>
                            <Grid container item xs={2} alignContent="center" justify="center" className={classes.bodyCells}>
                              {/* TODO // use when they implement edit bags */}
                              {/* <Grid container item xs={6} justify="center">
                                <Button variant="contained" size="small" style={{backgroundColor: '#6464f6'}} onClick={() => {setEditBag(bag); setEditBags(true)}}>edit</Button>
                              </Grid> */}
                              <Grid item xs={6}>
                                <Button variant="contained" size="small" style={{backgroundColor: '#eb494e'}} onClick={() => {handleDeleteConfirmation(bag)}}>remove</Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        ))
                      }
                  </Grid>
                  <Grid container item xs={12} justify="center">Total Bag Weight: {getBagWeightTotal(bags)}</Grid>
                  <Grid container item xs={12} justify="center" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                    {
                      addBag == false ?
                      <div>
                        <Button variant="contained" size="small" style={{backgroundColor: '#03fc66', marginRight: '5px'}} onClick={() => {setAddBag(true)}}>add</Button>
                        <Button variant="contained" size="small" style={{backgroundColor: '#eb494e'}} onClick={() => {props.closeModal(false)}}>close</Button>
                      </div>
                       :
                      <Grid container item xs={12} justify="center">
                        {/* !SECTION */}
                        {/* SECTION // Add Bag */}
                        <Grid container item xs={10} justify="center" style={{border: '2px solid gray', borderRadius: '10px'}}>
                          <Grid container item xs={12} justify="center">
                            <FormLabel component="legend">New Bag</FormLabel>
                          </Grid>
                          <Grid container item xs={3}>
                            <FormControl component="fieldset">
                            <RadioGroup aria-label="bag-type" name="new-bag-type" value={newBagType} onChange={(e) => {setNewBagType(e.target.value)}}>
                              <FormControlLabel value="checked" control={<Radio />} label="Checked" />
                              <FormControlLabel value="carry-on" control={<Radio />} label="Carry-on" />
                            </RadioGroup>
                          </FormControl>
                          </Grid>
                          <Grid container item xs={3} alignContent="center" style={{marginRight: '5px'}}>
                            <TextField
                              value={newBagWeight}
                              onChange={(e) => {setNewBagWeight(e.target.value)}}
                              id="bag-weight"
                              label="Weight"
                              type="number"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant="filled"
                            />
                          </Grid>
                          <Grid container item xs={3} alignContent="center" style={{marginBottom: '5px'}}>
                            <TextField
                              value={newBagNotes}
                              onChange={(e) => {setNewBagNotes(e.target.value)}}
                              multiline={true}
                              rows={3}
                              id="bag-notes"
                              label="Notes"
                              type="text"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant="filled"
                            />
                          </Grid>
                        </Grid>
                        <Grid container item xs={8} justify="center" style={{paddingTop: '10px'}}>
                          <Button variant="contained" size="small" style={{marginRight: '10px', backgroundColor: '#eb494e'}} onClick={() => {setAddBag(false)}}>cancel</Button>
                          <Button variant="contained" size="small" style={{backgroundColor: '#03fc66'}} onClick={() => {handlePostBag()}}>save</Button>
                        </Grid>
                        {/* !SECTION */}
                      </Grid>
                    }
                  </Grid>
                </Grid>
              }
            </Grid>
          }
        </Grid>
      </Paper>
    </Grid>
  )
}